// extracted by mini-css-extract-plugin
module.exports = {"contentDragDrop":"DragAndDropFile_contentDragDrop__2ckMU","inputDragDrop":"DragAndDropFile_inputDragDrop__2XFl5"};